import { useEffect, useState } from 'react';
import axios from 'axios';

const apikey = process.env.REACT_APP_API;

export default function useProgramPermissions(programName) {
    const companyCode = sessionStorage.getItem('Company_Code');
    const uid = sessionStorage.getItem('uid');

    const [permissions, setPermissions] = useState({});
    const [canView, setCanView] = useState(null); // null = still checking

    useEffect(() => {
        let cancelled = false;
        const check = async () => {
            try {
                const res = await axios.get(`${apikey}/get_user_permissions`, {
                    params: { Company_Code: companyCode, Program_Name: programName, uid },
                });
                if (cancelled) return;
                const details = res.data?.UserDetails || {};
                setPermissions(details);
                setCanView(details.canView === 'Y');
            } catch (err) {
                console.error('Error fetching user permissions:', err);
                if (!cancelled) setCanView(false);
            }
        };
        check();
        return () => { cancelled = true; };
    }, [companyCode, programName, uid]);

    return { permissions, canView };
}